import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsRight: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.08.16v15.68L11.92 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsRight
